<style>
    .selectSociety {
        width: 100% !important;
        /* max-width: fit-content; */
    }
</style>
<template>
    <div>
        <!-- Filters -->
        <b-card no-body>
            <b-card-header class="pb-50">
                <h5>Filter</h5>
            </b-card-header>
            <b-card-body>
                <b-row>
                    <b-col cols="12" md="6" class="mb-md-0 mb-2">
                        <location-filters
                            size="sm"
                            align="horizontal"
                            @filter="changeFilters"
                        />
                    </b-col>

                    <b-col cols="12" md="3" class="pt-0">
                        <label for="society_id">Society</label>
                        <Dropdown
                            id="society_id"
                            name="society_id"
                            size="sm"
                            v-model="society_id"
                            :options="societies"
                            filter
                            optionLabel="name"
                            optionValue="id"
                            placeholder="Select..."
                            class="w-full md:w-14rem selectSociety"
                            @change="changeSociety()"
                        >
                            <template #option="slotProps">
                                <div class="flex align-items-center">
                                    <div>{{ slotProps.option.name }} ({{ slotProps.option.code }})</div>
                                </div>
                            </template>
                        </Dropdown>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <!-- ./Filters -->

        <b-card no-body class="mb-0">
            <div class="m-2">
                <!-- Table Top -->
                <b-row>
                    <!-- Per Page -->
                    <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                        <label>Show</label>
                        <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="perPageOptions" :clearable="false"
                            class="per-page-selector d-inline-block mx-50 select-size-sm" />
                        <label>entries</label>
                    </b-col>
                    <!-- ./Per Page -->

                    <!-- Search & Button -->
                    <b-col cols="12" md="6">
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input v-model="searchQuery" class="d-inline-block mr-1" placeholder="Search..."
                                size="sm" />
                        </div>
                    </b-col>
                    <!-- ./Search & Button-->
                </b-row>
                <!-- ./Table Top -->
            </div>

            <!-- Table -->
            <b-table
                striped
                hover
                small
                ref="records"
                class="position-relative"
                :items="fetch"
                responsive
                :fields="columns"
                primary-key="id"
                :sort-by.sync="sortBy"
                show-empty
                empty-text="No records found"
                :sort-desc.sync="isSortDirDesc"
            >
                <template #cell(farmers)="data">
                    <span>{{ data.item.farmers.toLocaleString() }}</span>
                </template>

                <template #cell(hectares)="data">
                    <span>{{ data.item.hectares.toLocaleString('en-Us', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                </template>

                <template #cell(volume)="data">
                    <span>{{ data.item.volume.toLocaleString('en-Us', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                </template>

                <template #cell(requiredTags)="data">
                    <span>{{ data.item.requiredTags.toLocaleString() }}</span>
                </template>

                <template #cell(generatedTags)="data">
                    <span>{{ data.item.generatedTags.toLocaleString() }}</span>
                </template>

                <!-- Column: Actions -->
                <template #cell(actions)="data">
                    <b-row class="breadcrumb-slash d-flex justify-content-right">
                        <b-col cols="12">
                            <b-button
                                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                                :variant="data.item.requiredTags > data.item.generatedTags? 'flat-success' : 'flat-secondary'"
                                class="btn-icon"
                                :title="data.item.requiredTags > data.item.generatedTags? 'Generate Tags' : 'No Tags to Generate'"
                                :disabled="data.item.requiredTags > data.item.generateTags || generating"
                                @click="generateTags(data.item)"
                            >
                                <span v-if="!generating"><feather-icon icon="ArrowRightCircleIcon" /></span>
                                <b-spinner
                                    v-if="generating"
                                    small
                                    type="grow"
                                />
                                <span class="sr-only">Loading...</span>
                            </b-button>

                            <b-button
                                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                                :variant="data.item.extract? 'flat-success' : 'flat-secondary'"
                                class="btn-icon"
                                :disabled="!data.item.extract || extracting"
                                :title="data.item.extract? 'Download Excel File' : 'Nothing to download'"
                                @click="extractTagsExcel(data.item)"
                            >
                                <feather-icon v-if="!extracting" icon="DownloadCloudIcon" />
                                 <b-spinner
                                    v-if="extracting"
                                    small
                                    class="mr-1"
                                    label="Small Spinner"
                                    variant="success"
                                />
                            </b-button>
                        </b-col>
                    </b-row>
                </template>
            </b-table>

            <!-- Table Footer -->
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }} entries</span>
                    </b-col>
                    <!-- Pagination -->
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRecords"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import {
        BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
        BForm, BFormGroup,
        BButton, BFormSelect, BFormSelectOption, BFormInput, BDropdown, BDropdownItem,
        BSpinner, BFormCheckbox, BBadge, BAlert,
        BMedia, BMediaAside, BMediaBody, BAvatar,
        BBreadcrumb, BBreadcrumbItem,
    } from 'bootstrap-vue'
    import Ripple from 'vue-ripple-directive'
    import Dropdown from 'primevue/dropdown';
    import vSelect from 'vue-select'
    import { required } from '@validations'
    import store from '@/store'
    import axios from '@axios'
    import { ref, onUnmounted, onMounted, reactive } from '@vue/composition-api'
    import growerTagsStoreModule from '@/views/cromis/inventory/tags/growerTagsStoreModule'
    import useGrowerTagsList from '@/views/cromis/inventory/tags/useGrowerTagsList'
    import LocationFilters from '@core/components/cromis/filters/LocationFilters'
    import { quantity } from 'echarts/lib/util/number'

    export default {
        name: 'GrowerTags',
        components: {
            BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
            BForm, BFormGroup,
            BButton, BFormSelect, BFormSelectOption, BFormInput, BDropdown, BDropdownItem,
            BSpinner, BFormCheckbox, BBadge, BAlert,
            BMedia, BMediaAside, BMediaBody, BAvatar,
            vSelect,
            ValidationProvider,
            ValidationObserver,
            LocationFilters,
            Dropdown,
            BBreadcrumb, BBreadcrumbItem,
        },
        directives: {
            Ripple,
        },

        setup(props, context) {
            const tags = ref([])
            const societies = ref([])

            const generating = ref(false)
            const extracting = ref(false)
            const generator = ref({
                stage: 2,
                level_id: null,
                quantity: null,
            })

            const CROMIS_STORE_MODULE_NAME = 'cromis-tags'
            // Register module
            if (!store.hasModule(CROMIS_STORE_MODULE_NAME)) store.registerModule(CROMIS_STORE_MODULE_NAME, growerTagsStoreModule)

            // UnRegister on leave
            onUnmounted(() => {
                if (store.hasModule(CROMIS_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_STORE_MODULE_NAME)
            })

            onMounted(async () => {
                
            })

            const changeFilters = async (location) => {
                locationFilter.value = location != null? location.id : null

                // console.log('Location Filter Changed:', location)

                if(location != null && location.children.length == 0){
                    generator.value.stage = 1
                    await store.dispatch(`${CROMIS_STORE_MODULE_NAME}/societies`, { location_id: locationFilter.value }).then(response => {
                        societies.value = response.data.societies
                        societies.value.sort((a, b) => a.name.toUpperCase().localeCompare(b.name.toUpperCase()))
                        generator.value.stage = 1
                    })
                }
                else{
                    generator.value.stage = 2
                }
            }

            const changeSociety = async (society) => {
                 generator.value.stage = society_id.value == null? 1 : 0
            }

            const generateTags = async (item) => {
                generator.value.level_id = item.id
                generator.value.quantity = item.requiredTags - item.generatedTags

                if(generator.value.quantity > 0){
                    generating.value = true

                    await store.dispatch(`${CROMIS_STORE_MODULE_NAME}/generate`, generator.value).then(response => {
                        refetch()
                        generating.value = false
                    }).catch(() => {
                        generating.value = false
                    })
                }
            }

            const extractTagsExcel = async (item) => {
                extracting.value = true

                window.open(`${ axios.defaults.baseURL }/extract_tags?stage=${ generator.value.stage }&level_id=${ item.id }&quantity=${ item.generatedTags }`, '_blank')

                extracting.value = false
            }

            const {
                fetch,
                columns,
                perPage,
                currentPage,
                totalRecords,
                from,
                to,
                meta,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                records,
                refetch,

                // Filers
                resolveStatusVariant,
                resolveReceivedVariant,
                locationFilter,
                society_id,
            } = useGrowerTagsList()

            return {
                // Data
                tags,
                societies,
                society_id,
                generator,
                generating,
                extracting,
                
                // Table Handlers
                fetch,
                columns,
                perPage,
                currentPage,
                totalRecords,
                from,
                to,
                meta,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                records,
                refetch,
                changeFilters,
                changeSociety,
                generateTags,
                extractTagsExcel,
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '@core/scss/vue/libs/vue-select.scss';
</style>